import React, { useCallback } from "react";

import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Typography from "@material-ui/core/Typography";

import Button from "components/CustomButtons/Button";

const useStyles = makeStyles(theme => ({
  marginBottom: {
    marginBottom: theme.spacing(3)
  },
  dialogActions: {
    justifyContent: "center"
  }
}));

const DownloadDialog = ({ open, onClose, chapter, year, onOK }) => {
  const classes = useStyles();

  const handleSave = useCallback(() => {
    onOK();
  }, []);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      scroll="paper"
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>Download Budget Document</DialogTitle>
      <DialogContent>
        <Typography variant="body1" className={classes.marginBottom}>
          You will be downloading the budget document for {chapter} for the Year{" "}
          {year}. Click OK to Download
        </Typography>
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogActions }}>
        <Button color="success" variant="contained" onClick={handleSave}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DownloadDialog;
